import { FormComposer, Toast, Loader } from "@egovernments/digit-ui-react-components";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { newConfig } from "../components/config/config";
import SelectDateofEmployment from "../components/pageComponents/SelectDateofEmployment";
import resolveDepartmentAndCity from "../components/Utils/resolveDepartmentAndCity";

const CreateEmployee = () => {
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const [canSubmit, setSubmitValve] = useState(false);
  const [mobileNumber, setMobileNumber] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [phonecheck, setPhonecheck] = useState(false);
  const [checkfield, setcheck] = useState(false);
  const { t } = useTranslation();
  const history = useHistory();
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const userRoles = userDetails?.roles?.map((roleData) => roleData.code);
  const isSuperUser = userRoles?.includes("SUPERUSER") || userRoles?.includes("EMPLOYEE_ADMIN");
  const { department, city } = resolveDepartmentAndCity({
    tenantId,
    userDetails,
    isSuperUser,
  });

  const { data: mdmsData, isLoading } = Digit.Hooks.useCommonMDMS(Digit.ULBService.getStateId(), "egov-hrms", ["CommonFieldsConfig"], {
    select: (data) => {
      return {
        config: data?.MdmsRes?.["egov-hrms"]?.CommonFieldsConfig,
      };
    },
    retry: false,
    enable: false,
  });
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_HRMS_MUTATION_HAPPENED", false);
  const [errorInfo, setErrorInfo, clearError] = Digit.Hooks.useSessionStorage("EMPLOYEE_HRMS_ERROR_DATA", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_HRMS_MUTATION_SUCCESS_DATA", false);

  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
    clearError();
  }, []);

  const checkMailNameNum = (formData) => {
    const email = formData?.SelectEmployeeEmailId?.emailId || "";
    const name = formData?.SelectEmployeeName?.employeeName || "";
    /*
    const address = formData?.SelectEmployeeCorrespondenceAddress?.correspondenceAddress || '';
    */
    const validEmail = email.length == 0 ? true : email.match(Digit.Utils.getPattern("Email"));
    return validEmail && name.match(Digit.Utils.getPattern("Name")); // && address.match(Digit.Utils.getPattern('Address'));
  };
  useEffect(() => {
    if (mobileNumber && mobileNumber.length == 10 && mobileNumber.match(Digit.Utils.getPattern("MobileNo"))) {
      setShowToast(null);
      Digit.HRMSService.search(tenantId, null, { phone: mobileNumber }).then((result, err) => {
        if (result.Employees.length > 0) {
          setShowToast({ key: true, label: "ERR_HRMS_USER_EXIST_MOB" });
          setPhonecheck(false);
        } else {
          setPhonecheck(true);
        }
      });
    } else {
      setPhonecheck(false);
    }
  }, [mobileNumber]);

  const defaultValues = {
    Jurisdictions: [
      {
        id: undefined,
        key: 1,
        hierarchy: "REVENUE",
        boundaryType: "Locality",
        boundary: "up.tcpsolan",
        department,
        city,
        locality: null,
        areaType: null,
        village: [],
        roles: [],
      },
    ],
  };

  const onFormValueChange = (setValue = true, formData) => {
    console.log("formdatafromonformvaluechange", formData);

    if (formData?.SelectEmployeePhoneNumber?.mobileNumber) {
      setMobileNumber(formData?.SelectEmployeePhoneNumber?.mobileNumber);
    } else {
      setMobileNumber(formData?.SelectEmployeePhoneNumber?.mobileNumber);
    }
    // for (let i = 0; i < formData?.Jurisdictions?.length; i++) {
    //   let key = formData?.Jurisdictions[i];
    //   if (!(key?.city && key?.locality && key?.areaType && key?.tenantId && key?.roles?.length > 0)) {
    //     // key?.boundary && key?.boundaryType && key?.hierarchy &&
    //     setcheck(false);
    //     break;
    //   } else {
    //     setcheck(true);
    //   }
    // }

    // let setassigncheck = false;
    // for (let i = 0; i < formData?.Assignments?.length; i++) {
    //   let key = formData?.Assignments[i];
    //   if (
    //     !(key.department && key.designation && key.fromDate && (formData?.Assignments[i].toDate || formData?.Assignments[i]?.isCurrentAssignment))
    //   ) {
    //     setassigncheck = false;
    //     break;
    //   } else if (formData?.Assignments[i].toDate == null && formData?.Assignments[i]?.isCurrentAssignment == false) {
    //     setassigncheck = false;
    //     break;
    //   } else {
    //     setassigncheck = true;
    //   }
    // }
    formData["SelectDateofEmployment"] = {
      ...formData["SelectDateofEmployment"],
      dateOfAppointment: Date.now(),
    };

    formData["SelectEmployeeType"] = {
      ...formData["SelectEmployeeType"],
      code: "PERMANENT",
    };

    if (
      formData?.SelectDateofEmployment?.dateOfAppointment &&
      /*
      formData?.SelectEmployeeCorrespondenceAddress?.correspondenceAddress &&
      */
      formData?.SelectEmployeeGender?.gender.code &&
      formData?.SelectEmployeeName?.employeeName &&
      formData?.SelectEmployeeType?.code &&
      formData?.SelectEmployeePhoneNumber?.mobileNumber &&
      formData?.PasswordField &&
      formData?.permanentAddress &&
      formData?.correspondenceAddress &&
      // checkfield &&
      // setassigncheck &&
      phonecheck &&
      checkMailNameNum(formData)
    ) {
      setSubmitValve(true);
    } else {
      setSubmitValve(false);
    }
  };

  const navigateToAcknowledgement = (Employees) => {
    history.replace("/digit-ui/employee/hrms/response", { Employees, key: "CREATE", action: "CREATE" });
  };

  const onSubmit = (data) => {
    console.log("fromOnsubmitData", data);
    const selectedDepartment = data?.Jurisdictions?.[0]?.department.code;
    data.Jurisdictions[0]["department"] = data?.Jurisdictions?.[0]?.department?.name;
    const actualTenantId =
      selectedDepartment === "UP" ? "up" : selectedDepartment === "AVP" ? "up.avp" : selectedDepartment === "DA" ? "up.da" : null;
    console.log("fromsubmitactualTenantID", actualTenantId, selectedDepartment);

    if (data.Jurisdictions.filter((juris) => juris.tenantId == actualTenantId).length == 0) {
      setShowToast({ key: true, label: "ERR_BASE_TENANT_MANDATORY" });
      return;
    }
    if (
      !Object.values(
        data.Jurisdictions.reduce((acc, sum) => {
          if (sum && sum?.tenantId) {
            acc[sum.tenantId] = acc[sum.tenantId] ? acc[sum.tenantId] + 1 : 1;
          }
          return acc;
        }, {})
      ).every((s) => s == 1)
    ) {
      setShowToast({ key: true, label: "ERR_INVALID_JURISDICTION" });
      return;
    }
    let roles = data?.Jurisdictions?.map((ele) => {
      return ele.roles?.map((item) => {
        item["tenantId"] = actualTenantId;
        return item;
      });
    });

    const mappedroles = [].concat.apply([], roles);
    delete data?.Jurisdictions?.[0]?.tenantId;
    delete data?.Jurisdictions?.[0]?.roles;

    let Employees = [
      {
        tenantId: stateId,
        employeeStatus: "EMPLOYED",
        assignments: [
          {
            key: 1,
            fromDate: Date.now(),
            toDate: undefined,
            isCurrentAssignment: true,
            department: "TCP",
            designation: "CE",
          },
        ],
        /* removed code as suggested by Renuka
        code: data?.SelectEmployeeId?.code ? data?.SelectEmployeeId?.code : undefined,
        */
        dateOfAppointment: Date.now(),
        employeeType: "PERMANENT",
        jurisdictions: data?.Jurisdictions,
        user: {
          mobileNumber: data?.SelectEmployeePhoneNumber?.mobileNumber,
          password: data?.PasswordField,
          name: data?.SelectEmployeeName?.employeeName,
          /*
          correspondenceAddress: data?.SelectEmployeeCorrespondenceAddress?.correspondenceAddress,
          */
          // correspondenceAddress: data?.correspondenceAddress, type: "CORRESPONDENCE",
          // permanentAddress: data?.permanentAddress , type: "PERMANENT",
          correspondenceAddress: {
            ...data?.correspondenceAddress,
            type: "CORRESPONDENCE",
          },
          permanentAddress: {
            ...data?.permanentAddress,
            type: "PERMANENT",
          },
          emailId: data?.SelectEmployeeEmailId?.emailId ? data?.SelectEmployeeEmailId?.emailId : undefined,
          gender: data?.SelectEmployeeGender?.gender.code,
          dob: new Date(data?.SelectDateofBirthEmployment?.dob).getTime(),
          roles: mappedroles,
          // tenantId updated from jurisdictions city data as discussed with Renuka
          tenantId: actualTenantId,
        },
        serviceHistory: [],
        education: [],
        tests: [],
      },
    ];

    /* use customiseCreateFormData hook to make some chnages to the Employee object */
    Employees = Digit?.Customizations?.HRMS?.customiseCreateFormData ? Digit.Customizations.HRMS.customiseCreateFormData(data, Employees) : Employees;
    console.log("employeessPayload", Employees);

    if (data?.SelectEmployeeId?.code && data?.SelectEmployeeId?.code?.trim().length > 0) {
      Digit.HRMSService.search(tenantId, null, { codes: data?.SelectEmployeeId?.code }).then((result, err) => {
        if (result.Employees.length > 0) {
          setShowToast({ key: true, label: "ERR_HRMS_USER_EXIST_ID" });
          return;
        } else {
          navigateToAcknowledgement(Employees);
        }
      });
    } else {
      navigateToAcknowledgement(Employees);
    }
  };
  if (isLoading) {
    return <Loader />;
  }
  console.log("configfrommdmscreate", mdmsData);

  const config = mdmsData?.config ? mdmsData.config : newConfig;
  return (
    <div style={{ paddingBottom: "250px" }} >
      <FormComposer
        defaultValues={defaultValues}
        heading={t("HR_COMMON_CREATE_EMPLOYEE_HEADER")}
        config={config}
        onSubmit={onSubmit}
        onFormValueChange={onFormValueChange}
        isDisabled={!canSubmit}
        label={t("HR_COMMON_BUTTON_SUBMIT")}
      />
      {showToast && (
        <Toast
          error={showToast.key}
          label={t(showToast.label)}
          onClose={() => {
            setShowToast(null);
          }}
        />
      )}
    </div>
  );
};
export default CreateEmployee;
